
import Courthouse from "../../../assets/outline/Courthouse.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CourthouseIcon({ className, dataTestid = "CourthouseIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Courthouse data-testid={dataTestid} className={classes} {...rest} />
  );
}
